<template>
    <div class="thin-banner" :class="{'thin-banner--padding-top': paddingTop, 'thin-banner--padding-bottom': paddingBottom }">
        <picture>
            <source media="(min-width: 768px)" srcset="/images/events/2025/september-ten-day-new-car-campaign/thin-banner/desktop@1x.webp, /images/events/2025/september-ten-day-new-car-campaign/thin-banner/desktop@2x.webp 2x" type="image/webp">
            <source media="(min-width: 768px)" srcset="/images/events/2025/september-ten-day-new-car-campaign/thin-banner/desktop@1x.jpg, /images/events/2025/september-ten-day-new-car-campaign/thin-banner/desktop@2x.jpg 2x">
            <source srcset="/images/events/2025/september-ten-day-new-car-campaign/thin-banner/mobile@1x.webp, /images/events/2025/september-ten-day-new-car-campaign/thin-banner/mobile@2x.webp 2x" type="image/webp">
            <img srcset="/images/events/2025/september-ten-day-new-car-campaign/thin-banner/mobile@1x.jpg, /images/events/2025/september-ten-day-new-car-campaign/thin-banner/mobile@2x.jpg 2x" class="img-responsive" style="width: 100%;">
        </picture>
    </div>
</template>

<script>
export default {
    name: "ThinBanner",
    props: {
        paddingTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        paddingBottom: {
            type: Boolean,
            required: false,
            default: false,
        },
    }
}
</script>

<style scoped>
.thin-banner--padding-top {
    padding-top: 20px;
}

.thin-banner--padding-bottom {
    padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/ThinBanner.vue